import * as React from 'react';
import {
	FareFamilyOptionsType,
	FareFamilyPriceFragment,
	FlightClass,
	ResultsLegFragment,
	SegmentWithTransferFragment,
	FareFamilyFragment,
	PassengerFareFragment
} from '@websky/graphql';
import { Props } from './components/DesktopFlight';
import { Money, UseToggleable } from '../types';
import { SimpleFlight } from '../Results/types';

export enum Tabs {
	FlightInfo,
	EconomyFares,
	BusinessFares,
	MilesFares
}

export type UseDesktopFlight = (
	props: Props
) => {
	lastSelectedFare: string;
	subStatuses?: SubStatus[];
	flightSegments?: SegmentWithTransferFragment[];
	flightBlock: React.MutableRefObject<HTMLDivElement>;
	activeTab: Tabs;
	flight: ResultsLegFragment;
	getFareGroupTabHandler: (serviceClass: FlightClass) => () => void;
	handleFlightInfoTab: React.DispatchWithoutAction;
	handleEconomyFareGroupsTab: React.DispatchWithoutAction;
	handleBusinessFareGroupsTab: React.DispatchWithoutAction;
	handleMilesFareGroupsTab: React.DispatchWithoutAction;
	filteredPrices: FareFamilyPriceFragment[];
	economyFareGroups: FareFamilyPriceFragment[];
	businessFareGroups: FareFamilyPriceFragment[];
	milesFareGroups: FareFamilyPriceFragment[];
	getOnFareSelect: (group: FareFamilyPriceFragment) => () => void;
};

export type UseDesktopFlightWithPopup = (
	props: Props,
	defaultModalState?: boolean
) => ReturnType<UseDesktopFlight> & {
	isModalOpen: ReturnType<UseToggleable>['isOpen'];
	openModal: ReturnType<UseToggleable>['open'];
	closeModal: ReturnType<UseToggleable>['close'];
	upgradeOptions: UpgradeOptions;
	isComparisonOpen: ReturnType<UseToggleable>['isOpen'];
	setIsComparisonOpen: ReturnType<UseToggleable>['setOpen'];
};

export interface UpgradeOption {
	optionsAvailableOnNextFare: FareFamilyOptionsType[];
	canUpgradeTo?: FareFamilyPriceFragment;
	upgradeOffer: string;
}

export type FareFamilyId = string;
export type UpgradeOptions = Map<FareFamilyId, UpgradeOption>;

export type SubStatus = 'AwaitingExchange' | 'Upgrade';

export interface PriceWrapper {
	price?: Money;
	priceInMiles?: number;
	flight: {
		id?: string;
		canBePaidByMiles?: boolean;
		fares?: {
			passengerFares: PassengerFareFragment[];
		}[];
	};
}

export interface SelectedFare {
	fareGroupId: string;
	fareName?: string;
	prices?: PriceWrapper[];
	flightInfo?: SimpleFlight;
	fareFamily?: FareFamilyFragment;
	faresIds?: string[];
}
